import { createContext, useContext } from 'react';
import { GroupThemeRevision } from 'referral-types';

type GroupThemeRevisionContextType = {
  groupThemeRevision?: GroupThemeRevision;
  groupMediaOverride?: File | null;
};

export const GroupThemeRevisionContext = createContext<GroupThemeRevisionContextType | undefined>(undefined);

export const useGroupThemeRevision = () => {
  const context = useContext(GroupThemeRevisionContext);
  if (context === undefined) {
    throw new Error('useGroupThemeRevision must be used within a PageRevisionProvider');
  }
  return context;
};
